import { Form } from "@unform/web";
import { FormProvider } from "react-hook-form";

const FormWrapper = ({ children, submit, ...props }) => {
  return (
    <FormProvider {...props}>
      <Form onSubmit={props.handleSubmit(submit)}>{children}</Form>
    </FormProvider>
  );
};

export default FormWrapper;
